const isMbwayDetails = (details)=>{
    if (!details || typeof details !== 'object') {
        return false;
    }
    return 'phoneNumber' in details && !!details.phoneNumber;
};

export { isMbwayDetails };
//# sourceMappingURL=types.js.map
